/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RequestConvocationResignation model module.
 * @module model/RequestConvocationResignation
 * @version 1.0.0
 */
class RequestConvocationResignation {
    /**
     * Constructs a new <code>RequestConvocationResignation</code>.
     * @alias module:model/RequestConvocationResignation
     * @param justifyingDocs {Array.<File>} The justifying documentation that prove the reasons why the student needs to resign to the convocations.
     * @param annexDoc {File} The official annex document filled by the student.
     * @param comment {String} The student reason of the resignation request.
     */
    constructor(justifyingDocs, annexDoc, comment) { 
        
        RequestConvocationResignation.initialize(this, justifyingDocs, annexDoc, comment);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, justifyingDocs, annexDoc, comment) { 
        obj['justifying_docs'] = justifyingDocs;
        obj['annex_doc'] = annexDoc;
        obj['comment'] = comment;
    }

    /**
     * Constructs a <code>RequestConvocationResignation</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RequestConvocationResignation} obj Optional instance to populate.
     * @return {module:model/RequestConvocationResignation} The populated <code>RequestConvocationResignation</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RequestConvocationResignation();

            if (data.hasOwnProperty('ordinary_resignation_enroll_ids')) {
                obj['ordinary_resignation_enroll_ids'] = ApiClient.convertToType(data['ordinary_resignation_enroll_ids'], ['Number']);
            }
            if (data.hasOwnProperty('extraordinary_resignation_enroll_ids')) {
                obj['extraordinary_resignation_enroll_ids'] = ApiClient.convertToType(data['extraordinary_resignation_enroll_ids'], ['Number']);
            }
            if (data.hasOwnProperty('justifying_docs')) {
                obj['justifying_docs'] = ApiClient.convertToType(data['justifying_docs'], [File]);
            }
            if (data.hasOwnProperty('annex_doc')) {
                obj['annex_doc'] = ApiClient.convertToType(data['annex_doc'], File);
            }
            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
        }
        return obj;
    }


}

/**
 * The enroll ids which are requested for an ordinary convocation resignation.
 * @member {Array.<Number>} ordinary_resignation_enroll_ids
 */
RequestConvocationResignation.prototype['ordinary_resignation_enroll_ids'] = undefined;

/**
 * The enroll ids which are requested for an extraordinary convocation resignation.
 * @member {Array.<Number>} extraordinary_resignation_enroll_ids
 */
RequestConvocationResignation.prototype['extraordinary_resignation_enroll_ids'] = undefined;

/**
 * The justifying documentation that prove the reasons why the student needs to resign to the convocations.
 * @member {Array.<File>} justifying_docs
 */
RequestConvocationResignation.prototype['justifying_docs'] = undefined;

/**
 * The official annex document filled by the student.
 * @member {File} annex_doc
 */
RequestConvocationResignation.prototype['annex_doc'] = undefined;

/**
 * The student reason of the resignation request.
 * @member {String} comment
 */
RequestConvocationResignation.prototype['comment'] = undefined;






export default RequestConvocationResignation;

